module.exports = __webpack_public_path__ + "static/media/Two_Hand_C.fe0fe45c.png";